module.exports = __webpack_public_path__ + "img/invoice-de-male-he.d1f312bb.png";